export async function EncryptData(data: any) {
    const plainText = JSON.stringify(data);
    const plainBytes = new TextEncoder().encode(plainText);

    const encryptedBytes = await encrypt(plainBytes);
    const dados = arrayBufferToBase64(encryptedBytes);
    return dados;
}

async function getAesKey(secretKey: string) {
    // Função auxiliar para converter uma string em um ArrayBuffer
    function stringToArrayBuffer(str: string) {
        const encoder = new TextEncoder();
        return encoder.encode(str);
    }

    // Função auxiliar para gerar um ArrayBuffer para a chave e IV
    function generateKeyAndIv(secretKey: string) {
        const keyBytes = new Uint8Array(16); // 128 bits / 16 bytes
        const secretKeyBytes = stringToArrayBuffer(secretKey);

        // Copiar bytes da chave secreta para a chave de 16 bytes
        keyBytes.set(secretKeyBytes.slice(0, 16)); // Ajusta o tamanho para 16 bytes

        return {
            key: keyBytes,
            iv: keyBytes // O mesmo valor para IV, embora normalmente seja diferente
        };
    }

    // Gerar chave e IV
    const { key, iv } = generateKeyAndIv(secretKey);

    // Importar chave para uso no Crypto API
    const cryptoKey = await crypto.subtle.importKey(
        'raw',
        key,
        { name: 'AES-CBC', length: 128 }, // AES-CBC com chave de 128 bits
        false,
        ['encrypt', 'decrypt'] // Permissões para criptografar e descriptografar
    );

    // IV deve ser gerado aleatoriamente em uma aplicação real
    // Aqui estamos apenas usando a mesma chave como IV para simplificação
    return {
        key: cryptoKey,
        iv: iv
    };
}

async function encrypt(plainBytes: Uint8Array) {
    const { key, iv } = await getAesKey(import.meta.env.VITE_APP_KEY);
    // Converta os dados de plainBytes (Uint8Array) para ArrayBuffer, se necessário
    const plainArrayBuffer = plainBytes.buffer.slice(plainBytes.byteOffset, plainBytes.byteOffset + plainBytes.byteLength);

    // Criptografe os dados
    const encryptedBuffer = await crypto.subtle.encrypt(
        {
            name: 'AES-CBC',
            iv: iv // Vetor de Inicialização (IV)
        },
        key, // Chave AES
        plainArrayBuffer // Dados a serem criptografados
    );

    // Retorne o resultado como Uint8Array
    return new Uint8Array(encryptedBuffer);
}

function arrayBufferToBase64(buffer: Uint8Array) {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    bytes.forEach((byte) => binary += String.fromCharCode(byte));
    return btoa(binary);
}